import request from "../utils/request";

/**
 * 未出勤学员 —— 一周 / 一个月 / 多个月未出勤订单列表（加盟商自助导出）
 *
 * 后端口径：orders(state='已激活' AND remaining>0) × courses 按 student_id 精确判定，
 * 学员在所选回溯窗口内无任何签课记录即为未出勤。
 * 所有接口后端均强制「请求区域 ∩ 本人辖区」，加盟商无法越权导出他人校区数据。
 */

/**
 * 未出勤学员分页列表
 * @param query { areaIdList, period:1一周/2一月/3多月, months, expiringDays, manageWay, keyword, serveCoachName, pageIndex, pageSize }
 */
export const absentPage = (query) => {
    return request({
        url: '/sys/absentStudent/page',
        method: 'post',
        data: query
    });
}

/**
 * 未出勤学员 按校区汇总（看板）
 */
export const absentSummary = (query) => {
    return request({
        url: '/sys/absentStudent/summary',
        method: 'post',
        data: query
    });
}

/**
 * 未出勤学员明细导出（文件在右上角下载中心取）
 */
export const exportAbsent = (query) => {
    return request({
        url: '/sys/absentStudent/export',
        method: 'post',
        data: query
    });
}

/**
 * 未出勤学员 按校区汇总导出
 */
export const exportAbsentSummary = (query) => {
    return request({
        url: '/sys/absentStudent/exportSummary',
        method: 'post',
        data: query
    });
}